import { useEffect, useState } from "react";
import { Link, useLocation } from "wouter";
import { useTranslation } from "react-i18next";
import { Sakura } from "../components/shrine/Sakura";
import { ensureSeedPair, getPairs, type StoredPair } from "../lib/storage";

export function PairLaunch() {
  const { t } = useTranslation();
  const [, navigate] = useLocation();
  const [pairs, setPairs] = useState<StoredPair[]>([]);

  useEffect(() => {
    ensureSeedPair(); // 開発体験のため最低1ペア
    setPairs(getPairs());
  }, []);

  return (
    <main className="relative min-h-dvh bg-[var(--color-night-deep)] text-[var(--color-washi)] px-6 py-10 overflow-hidden">
      <Sakura count={6} />
      <header className="relative z-10 mb-8">
        <Link
          href="/home"
          className="text-xs text-[var(--color-gold-light)] opacity-60 tracking-widest"
        >
          ← {t("common.back")}
        </Link>
        <h1
          className="mt-4 text-2xl tracking-[0.2em] text-[var(--color-gold-light)]"
          style={{ fontFamily: "var(--font-fude)" }}
        >
          {t("pair.selectPartner")}
        </h1>
      </header>

      <ul className="relative z-10 flex flex-col gap-3">
        {pairs.length === 0 && (
          <p className="opacity-60 text-sm">{t("pair.noPairs")}</p>
        )}
        {pairs.map((p) => (
          <li key={p.pairId}>
            <button
              onClick={() => navigate(`/pair/${p.pairId}/ritual`)}
              className="w-full p-4 rounded-2xl bg-[var(--color-night)]/70 border border-[var(--color-gold)]/25 hover:border-[var(--color-gold)]/60 active:scale-[0.98] transition flex items-center justify-between"
            >
              <div className="text-left">
                <p
                  className="text-lg tracking-widest"
                  style={{ fontFamily: "var(--font-fude)" }}
                >
                  {p.partnerName}
                </p>
                <p className="text-[10px] opacity-60 tracking-wider mt-1">
                  {t("pair.totalDraws", { n: p.totalDraws })} ・{" "}
                  {t("pair.currentStreak", { n: p.currentStreak })}
                </p>
              </div>
              <span className="text-xl text-[var(--color-shu-light)]">→</span>
            </button>
          </li>
        ))}
      </ul>
    </main>
  );
}
